module.exports = __webpack_public_path__ + "8bef4f2706359c698a1b45610bb96ccd.svg";